import styled from "styled-components";

export const TechnicalIssueContentContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: fixed;
    top: 40%;
    flex-direction: column;
    z-index: 999;
`;

export const TechnicalIssueContentLabel = styled.label`
    font-size: 19px;
    line-height: 21px;
    color: #545454;
    text-align: center;
    width: 65%;
`;

export const TechnicalIssueImage = styled.img`
    margin: 6px;
`;


// WEBPACK FOOTER //
// ./src/Components/TechnicalIssue/TechnicalIssueStyle.js